<template>
    <div v-if="loaded" id="customer-reviews-container">
        <div v-if="!error">
            <div v-if="reviews.length">
                <div class="testimonial-item" v-for="review in reviews" :key="'review-' + review.id">
                    <div class="testimonial-item-header">
                        <div class="testimonial-item-header-icon" style="background: #03dbe8;">{{ review.author.charAt(0).toUpperCase() }}</div>
                        <div class="testimonial-item-header-block">
                            <span class="name" itemprop="author">{{ review.author }}</span>
                            <span v-if="review.city" class="city">{{ review.city }}</span>
                        </div>
                        <div class="testimonial-item-header-block ml-md-auto mt-3 mb-3">
                            <div class="testimonial-item-content-tags">
                            <span class="item">
                                Оценка товара
                                <span>
                                    {{ review.rating }}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path fill="" d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/>
                                    </svg>
                                </span>
                            </span>
                            </div>
                        </div>
                        <div class="testimonial-item-header-block">
                            <span class="date">{{ review.posted_at }}</span>
                        </div>
                    </div>
                    <div class="testimonial-item-content">
                        <a :href="review.product.url">
                            <img width="90px" :src="review.product.image" :alt="review.product.article">
                        </a>
                        <div class="testimonial-item-content-text">
                            <h4>
                                {{ review.product.title }}
                                <span>{{ review.product.article }}</span>
                            </h4>
                            <p>{{ review.text }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="pagination && pagination.total_pages > 1">
                <pagination :current-page="pagination.current_page" :total-pages="pagination.total_pages" @setPage="setPage"></pagination>
            </div>

            <div v-if="!reviews.length">Вы пока не оставляли отзывов на нашем сайте</div>
        </div>

        <div v-if="error">{{ error }}</div>
    </div>
</template>

<script>
    import Pagination from '../../Pagination.vue';

    export default {
        name: 'CustomerProductReviews',
        components: {
            Pagination,
        },
        props: {
            //
        },
        data: function () {
            return {
                reviews: [],
                pagination: null,
                page: 1,
                error: null,
                loading: true,
            }
        },
        mounted: function () {
            this.load();
        },
        watch: {
            page (newValue, oldValue) {
                let container = document.getElementById('customer-reviews-container');

                if (container) {
                    container.scrollIntoView({
                        behavior: 'smooth',
                    });
                }
            }
        },
        methods: {
            load () {
                let _this = this;

                _this.error = null;

                axios.get(_this.page > 1 ? '?page=' + _this.page : '')
                    .then(response => {
                        if (response.data.status === 'success') {
                            _this.reviews = response.data.reviews.data;

                            _this.pagination = response.data.reviews.meta.pagination;
                        } else if (response.data.message) {
                            _this.error = response.data.message;
                        }

                        _this.loading = false;
                    })
                    .catch(error => {
                        _this.error = 'Упс... Произошла ошибка при выполнении запроса.';

                        _this.loading = false;
                    });
            },

            setPage (page) {
                this.page = page;

                this.load();
            }
        },
        computed: {
            loaded () {
                return ! this.loading;
            }
        }
    }
</script>
